import { Controller } from "stimulus";

export default class extends Controller
{
    static targets = ["hidden", "input", "arrow", "dropdown", "whiteSpace"];
    DATA = [];
    TYPE = "double";
    CURRENT_ACTIVE_INDEX = -1;

    connect()
    {
        this.setupDropdown();
    }

    setupDropdown()
    {
        this.DATA = Array.from(this.dropdownTarget.children).map(option =>
        {
            let { name, prefix, start, end } = option.dataset;

            return {
                name, prefix, start, end
            }
        });

        this.addHideDropdownEL();

        this.arrowTarget.addEventListener("click", e => 
        {
            if (this.arrowTarget.firstElementChild.style.transform == "rotate(360deg)" ||
                this.arrowTarget.firstElementChild.style.transform == "rotate(0deg)")
            {
                this.resetOptions();

                this.showActiveElement();

                this.openDropdown();
            }
            else
            {
                this.closeDropdown();
            }
        });

        Array.from(this.dropdownTarget.children).forEach(option =>
            option.addEventListener("click", e => this.optionClickEventHandler(option, e))
        );

        this.inputTarget.addEventListener("focus", e =>
        {
            if(this.dropdownTarget.classList.contains("toast-invisible"))
                this.arrowTarget.click();

            this.showActiveElement();
        })

        //Tabulation
        this.inputTarget.addEventListener("keydown", e =>
        {
            if(e.key == "Tab" || (e.key == "Tab" && e.shiftKey))
            {
                this.closeDropdown();
                // if(inputField.value == "") this.CURRENT_ACTIVE_ITEM = -1;
            }
        })

        //Navigation with arrows
        this.inputTarget.addEventListener("keydown", e =>
        {
            if(e.key != "ArrowDown" && e.key != "ArrowUp") return;

            e.preventDefault();


            if(this.CURRENT_ACTIVE_INDEX != -1)
            {
                let currentElement = this.dropdownTarget.children[this.CURRENT_ACTIVE_INDEX];
                currentElement.classList.remove("active");
            }

            if(e.key == "ArrowDown" && this.CURRENT_ACTIVE_INDEX != this.dropdownTarget.children.length-1)
            {
                this.CURRENT_ACTIVE_INDEX++;
            }
            else if (e.key == "ArrowUp" && this.CURRENT_ACTIVE_INDEX > 0)
            {
                this.CURRENT_ACTIVE_INDEX--;
            }
        
            let caretPosition = this.inputTarget.value.length,
                nextElement = this.dropdownTarget.children[this.CURRENT_ACTIVE_INDEX];

            let dropdownScroll = this.dropdownTarget.scrollTop,
                yTopToTop = nextElement.getBoundingClientRect().y - this.dropdownTarget.getBoundingClientRect().y,
                yBottomToBottom = nextElement.getBoundingClientRect().bottom - this.dropdownTarget.getBoundingClientRect().bottom;

            if(yTopToTop < 0)
            {
                this.dropdownTarget.scrollTo({top: dropdownScroll + yTopToTop, behavior: "smooth"})
            }
            else if (yBottomToBottom > 0)
            {
                this.dropdownTarget.scrollTo({top: dropdownScroll + yBottomToBottom, behavior: "smooth"})
            }

            nextElement.classList.add("active");
            this.inputTarget.setSelectionRange(caretPosition, caretPosition)
            // inputField.value = selectedElement.lastElementChild.textContent;
            // hiddenField.value = selectedElement.dataset["value"];
        })

        //Escape
        this.inputTarget.addEventListener("keydown", e =>
        {
            if(e.key != "Escape") return;
            this.closeDropdown();
        })

        //Enter
        this.inputTarget.addEventListener("keydown", e =>
        {
            if(e.key == "Enter" && !this.dropdownTarget.classList.contains("toast-invisible"))
            {
                e.preventDefault();
                if(this.CURRENT_ACTIVE_INDEX != -1)
                {
                    let selectedElement = this.dropdownTarget.children[this.CURRENT_ACTIVE_INDEX];
                    selectedElement.click();
                }
                else this.closeDropdown();
            }
            else if (e.key == "Enter" && this.dropdownTarget.classList.contains("toast-invisible"))
            {
                e.preventDefault();

                this.resetOptions();
                this.openDropdown();
            }
        })

        this.inputTarget.addEventListener("input", e =>
        {
            let query = this.inputTarget.value.toLowerCase();
            this.hiddenTarget.value = query;

            this.CURRENT_ACTIVE_INDEX = -1;
            this.dropdownTarget.scrollTo({ top:0, behavior: "smooth" })

            if (query == "")
            {
                this.hiddenTarget.value = "";
                    this.resetOptions()
                return;
            }

            let filteredOptions = this.DATA.filter(option =>
            {
                return option.name.toLowerCase().includes(query) ||
                    option.prefix.toLowerCase().includes(query) ||
                    option.end.toLowerCase().includes(query)
                    option.start.toLowerCase().includes(query)
            });

            if (filteredOptions.length == 0)
            {
                this.closeDropdown();
                return;
            }

            let optionElements = filteredOptions.map(option => this.createOptionElement(option));

            this.dropdownTarget.innerHTML = "";
            this.dropdownTarget.append(...optionElements);
            this.dropdownTarget.classList.remove("toast-invisible");
            this.inputTarget.style.borderBottomLeftRadius = "0";
            this.inputTarget.style.borderBottomRightRadius = "0";
        })

        this.inputTarget.addEventListener("focusout", e =>
        {
            let query = this.inputTarget.value;
            let option = this.DATA.find(group => group.name == query);

            this.hiddenTarget.value = (option) ? option.code : query;
        })
    }

    optionClickEventHandler(option, e)
    {
        this.inputTarget.value = option.dataset["name"];
        this.inputTarget.dataset.name = option.dataset.name;
        this.inputTarget.dataset.prefix = option.dataset.prefix;
        this.inputTarget.dataset.start = option.dataset.start;
        this.inputTarget.dataset.end = option.dataset.end;
    
        this.hiddenTarget.value = option.dataset["name"];

        this.CURRENT_ACTIVE_INDEX = Array.from(this.dropdownTarget.children).indexOf(option);

        this.getXmits(option);

        this.closeDropdown();
        setTimeout(() => this.resetOptions(), 100);
    }

    createOptionElement(option)
    {
        let div = document.createElement("div");
        div.classList.add("item");
        div.dataset.name = option.name;
        div.dataset.prefix = option.prefix;
        div.dataset.start = option.start;
        div.dataset.end = option.end;

        div.innerHTML = `<span>${option.name}</span><span>Prefix: ${option.prefix}, ${option.start}-${option.end}</span>`

        div.addEventListener("click", e => this.optionClickEventHandler(div, e));

        return div;
    }

    resetOptions()
    {
        let options = this.DATA.map(option => this.createOptionElement(option));
        this.dropdownTarget.innerHTML = "";
        this.dropdownTarget.append(...options);
    }

    addHideDropdownEL()
    {
        document.addEventListener("click", e =>
        {
            if (e.target == this.dropdownTarget ||
                this.dropdownTarget.contains(e.target) ||
                e.target == this.inputTarget ||
                this.arrowTarget.contains(e.target)
            ) return;
            else this.closeDropdown();
        })
    }

    openDropdown()
    {
        this.arrowTarget.firstElementChild.style.transform = "rotate(180deg)";
        this.dropdownTarget.classList.remove("toast-invisible");

        this.inputTarget.classList.add("straight-corners");
        this.whiteSpaceTarget.classList.remove("hidden");

        // inputField.style.borderBottomLeftRadius = "0";
        // inputField.style.borderBottomRightRadius = "0";

        if(this.CURRENT_ACTIVE_INDEX != -1)
        {
            let selectedElement = this.dropdownTarget.children[this.CURRENT_ACTIVE_INDEX];
            selectedElement.classList.add("active");
        }
    }

    closeDropdown()
    {
        this.dropdownTarget.classList.add("toast-invisible");
        this.arrowTarget.firstElementChild.style.transform = "rotate(0deg)";

        this.inputTarget.classList.remove("straight-corners");
        this.whiteSpaceTarget.classList.add("hidden");

        // inputField.style.borderBottomLeftRadius = "";
        // inputField.style.borderBottomRightRadius = "";
    }

    showActiveElement()
    {
        if(this.inputTarget.value && this.CURRENT_ACTIVE_INDEX == -1)
        {
            let { name, prefix, start, end } = this.inputTarget.dataset;

            let index = Array.from(this.dropdownTarget.children).findIndex(el => el.dataset.name == name &&
                                                                      el.dataset.prefix == prefix &&
                                                                      el.dataset.start == start &&
                                                                      el.dataset.end == end)

            if(index >= 0)
            {
                this.CURRENT_ACTIVE_INDEX = index;
                let active = this.dropdownTarget.children[this.CURRENT_ACTIVE_INDEX];

                active.classList.add("active");

                let dropdownScroll = this.dropdownTarget.scrollTop,
                    yBottomToBottom = active.getBoundingClientRect().bottom - this.dropdownTarget.getBoundingClientRect().bottom;

                this.dropdownTarget.scrollTo({top: dropdownScroll + yBottomToBottom, behavior: "smooth"})
            }
        }
    }

    getXmits(option)
    {
        let {name, prefix, start, end} = option.dataset;

        let startLoadingEvent = new CustomEvent("start-loading");
        let xmitSearchElement = option.closest(".xmit-search");
        xmitSearchElement.dispatchEvent(startLoadingEvent);

        fetch("/sites/new/xmits",
        {
            method: 'POST',
            body: JSON.stringify({ name, prefix, start, end }),
            headers: { "content-type": "application/json" }
        })
        .then(r => r.json())
        .then(data => 
        {
            let e = new CustomEvent("load-xmits", { detail: data });
            xmitSearchElement.dispatchEvent(e);
        })
        .catch(e => 
        {
            const errorEvent = new CustomEvent("show-toast", { detail: "An error occurred: "+e.message })
            window.dispatchEvent(errorEvent);
        })
        .finally(() =>
        {
            let stopLoadingEvent = new CustomEvent("stop-loading");
            xmitSearchElement.dispatchEvent(stopLoadingEvent);
        })

    }
}